export default __webpack_public_path__ + "static/media/woodBackground.6adac92a.webp";